import apiService from "../../ApiService";

export const stcGenerateToken = (msisdn: string) => {
  return apiService.post<unknown>({
    path: `v1/store/stc/get_token`,
    body: { msisdn },
    requiresAuthPolicy: "user",
  });
};
